const rel = 'nofollow me noopener noreferrer';

export {
    rel
};
